<div class="d-flex flex-column w-100 p-0 m-0">
  <div class="flex-grow-1">
    <app-header></app-header>
  </div>
  <div class="flex-grow-1">
    <div class="Page_wrapper">
      <div
        class="Page_wrapper_banner"
        [ngClass]="{ static: bannerInnerHtml !== null }">
        <div
          [ngClass]="{ Page_wrapper_banner_static: bannerInnerHtml !== null }"
          #banner
          [innerHtml]="bannerInnerHtml"></div>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="flex-grow-1">
    <app-footer></app-footer>
  </div>
</div>
